'use client';

import { useState } from 'react';

import { useRouter } from 'next/navigation';

import { HeroUIProvider } from '@heroui/system';
import { HeroHookFormProvider } from '@rachelallyson/hero-hook-form';
import { Provider as RollbarProvider } from '@rollbar/react';
import { heroHookFormDefaults } from '@Soultrics/_components/HeroHookForm';
import { PHProvider } from '@Soultrics/_utils/posthog';
import { clientConfig } from '@Soultrics/rollbar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // 5 minutes
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 5 * 60 * 1000,
          },
        },
      })
  );

  return (
    <RollbarProvider config={clientConfig}>
      <QueryClientProvider client={queryClient}>
        <HeroUIProvider navigate={(href: string) => router.push(href)}>
          <HeroHookFormProvider defaults={heroHookFormDefaults}>
            <PHProvider>{children}</PHProvider>
          </HeroHookFormProvider>
        </HeroUIProvider>
      </QueryClientProvider>
    </RollbarProvider>
  );
}
export default Providers;
